import React from 'react';
import { spacing, colors, borderRadius } from './tokens';

/**
 * AdminFilterBar
 * 
 * Standardized filter bar component for admin pages.
 * 
 * @param {ReactNode} filters - Filter controls (left side)
 * @param {ReactNode} actions - Quick actions (right side)
 */
export default function AdminFilterBar({ filters, actions }) {
  return (
    <div className="admin-toolbar">
      <div style={{ display: 'flex', gap: 'var(--spacing-4)', alignItems: 'flex-end', flexWrap: 'wrap', flex: 1 }}>
        {filters}
      </div>
      {actions && (
        <div style={{ display: 'flex', gap: 'var(--spacing-2)', alignItems: 'center', flexShrink: 0 }}>
          {actions}
        </div>
      )}
    </div>
  );
}

// Styles removed - now using CSS classes from admin-ui.css

